/**
 * Can't simply use btoa because of UTF-16 encoding issues. Use this in place of it.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
 *
 * @param {String}
 * @returns {String}
 */
export const base64Encode = (str) => {
  const match = (m, p1) => String.fromCharCode(`0x${p1}`);
  const decodedUrl = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, match);
  return btoa(decodedUrl);
};
